import { useState } from "react";
import { CurrencyFormatter } from "@equidefi/i18n";
import { Text, BannerAlert, Modal, RadioGroup } from "@equidefi/ui";
import { formatSecurities, offeringHidesSecurityLabel } from "@equidefi/shared";

export const InvestmentRoundingModal = ({
  isOpen,
  onClose,
  onContinue,
  originalAmount,
  offering,
  suggestedAmount,
  unitPrice,
  minInvestment,
}) => {
  const [selection, setSelection] = useState("round-up");

  const handleContinue = () => {
    if (selection === "round-up") {
      onContinue(suggestedAmount);
    } else {
      onContinue(null); // Signal to let user enter different amount
    }
  };

  const minShares = minInvestment ? Math.ceil(minInvestment / unitPrice) : 1;
  const hideSecurityLabel = offeringHidesSecurityLabel(offering);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Investment Amount"
      closeOnOverlayClick={false}
      contentProps={{
        maxW: { base: "full", md: "540px" },
        w: { base: "full", md: "540px" },
      }}
      buttons={[
        {
          label: "Continue",
          action: handleContinue,
          w: "full",
          size: "lg",
          borderRadius: "8px",
          py: 6,
          bgGradient: "linear(to-t, blue.900, blue.700)",
          color: "white",
          fontWeight: "600",
          fontSize: "16px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          _hover: {
            bgGradient: "linear(to-t, blue.800, blue.600)",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
          },
          _active: {
            bgGradient: "linear(to-t, blue.900, blue.800)",
            transform: "translateY(0)",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          },
        },
      ]}>
      <Text fontSize="16px" lineHeight="1.5" mb="6" color="gray.700">
        Your investment amount must be a multiple of {hideSecurityLabel ? "" : "the "}
        {CurrencyFormatter.format(unitPrice)}
        {!hideSecurityLabel && ` ${offering?.security_type_label?.toLowerCase()} price`}. You can continue with the
        suggested amount below or enter a different amount.
      </Text>

      <RadioGroup
        value={selection}
        onChange={setSelection}
        direction="vertical"
        options={[
          {
            value: "round-up",
            label: `Invest ${CurrencyFormatter.format(suggestedAmount)}`,
          },
          {
            value: "different",
            label: "Enter a different amount",
          },
        ]}
      />

      <BannerAlert
        status="warning"
        description={
          <>
            Please note the minimum amount you can invest is {CurrencyFormatter.format(minInvestment || unitPrice)}
            {!hideSecurityLabel && ` (${formatSecurities({ quantity: minShares, offering }).toString()})`}.
          </>
        }
        mb={0}
      />
    </Modal>
  );
};
